// Angular
import { Injectable } from '@angular/core';
// Translation
import { TranslateService } from '@ngx-translate/core';
import { TranslationKey } from './TranslationConstants';
var cookie = require('./cookieManager.js');
export interface Locale {
  lang: string;
  data: Object;
}

@Injectable()
export class NgxTranslateService {
  // Private properties
  private langIds: any = [];

  /**
   * Service Constructor
   *
   * @param translate: TranslateService
   */
  constructor(private translate: TranslateService) {
    // add new langIds to the list
    this.translate.addLangs([TranslationKey.ENGLISH, TranslationKey.SPANISH, TranslationKey.FRENCH]);

    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang(TranslationKey.ENGLISH);
  }

  /**
   * Load Translation
   *
   * @param args: Locale[]
   */
  loadTranslations(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(locale => {
      // use setTranslation() with the third argument set to true
      // to append translations instead of replacing them
      this.translate.setTranslation(locale.lang, locale.data, true);

      this.langIds.push(locale.lang);
    });

    // add new languages to the list
    this.translate.addLangs(this.langIds);
  }

  /**
   * Setup language
   *
   * @param lang: any
   */
  setLanguage(lang:string) {
    if (lang) {
      this.translate.use(this.translate.getDefaultLang());
      this.translate.use(lang);
      cookie.set(TranslationKey.PAYCORCULTURE, lang);
    }
  }

  /**
   * use selected language
   */
  getSelectedLanguage(): any {
    var lang = cookie.get(TranslationKey.PAYCORCULTURE) || this.translate.getDefaultLang();
    this.translate.use(lang);
  }

  /**
   * Returns translated text 
   */
  getText(key : string, defaultText: string): any{
   
   return this.translate.instant(key, {Default: defaultText});
  }

  /**
   * Setup default language
   *  
   */
   setDefaultLang() {    {
      this.translate.use(this.translate.getDefaultLang());
      cookie.set(TranslationKey.PAYCORCULTURE, this.translate.getDefaultLang());
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/shared/ngx-translate.service.ts